export default __webpack_public_path__ + "static/media/md-card-bg-adv-java.a895e83c.png";